import Footer from "./pages/Footer.js";
import Header from "./pages/Header.js";
import "./App.css";
import "./pages/global.css";
import Home from "./pages/Home.js";
import { Route, Routes } from "react-router-dom";
import "../src/pages/MediaQuery.css";
import { useEffect, useState } from "react";

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
